// Dependencies
import { FC } from "react";

// Components
import ResetPasswordForm from "~/containers/ResetPasswordForm";

// Styles
import { StyledResetPasswordBackground } from "./ResetPassword.styled";

interface ResetPasswordProps {}

const ResetPassword: FC<ResetPasswordProps> = () => {
  return (
    <StyledResetPasswordBackground>
      <ResetPasswordForm />
    </StyledResetPasswordBackground>
  );
};

export default ResetPassword;
